export const CL_VIDEO_FEATURED = 'CL_VIDEO_FEATURED';
export const CL_VIDEO_RECOMMENDED = 'CL_VIDEO_RECOMMENDED';
export const CL_VIDEO_WATCHED = 'CL_VIDEO_WATCHED';
export const CL_VIDEO_DETAILS = 'CL_VIDEO_DETAILS';
